import { CreateDedicationRequestBody, CreateDedicationResponse } from 'models/Dedication'
import { api } from '../api'

export const dedicationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createDedication: builder.mutation<
      CreateDedicationResponse,
      CreateDedicationRequestBody & { transactionId: string; transactionToken: string }
    >({
      query: ({ transactionId, transactionToken, ...details }) => ({
        method: 'POST',
        url: `/transactions/${transactionId}/dedication`,
        body: { ...details, transactionId },
        headers: {
          transaction_token: transactionToken,
        },
      }),
    }),
  }),
})

export const {
  useCreateDedicationMutation,
  endpoints: { createDedication },
} = dedicationsApi
